import { toast } from "react-toastify";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { sendFeedback } from "@/lib/collections/feedback/sendFeedback";
import { Button } from "@/components/ui/button";
import { Loader, MessageSquareMore, Send } from "lucide-react";

const Feedback = () => {
    const { user } = useAuth();
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [isSendingFeedback, setIsSendingFeedback] = useState(false);

    const handleSendFeedback = async () => {
        if (!user) return;
        if (!title.trim() || !description.trim()) {
            toast.warning("Por favor el llena título y la descripción.");
            return;
        }
        try {
            setIsSendingFeedback(true);

            await sendFeedback(user.$id, title.trim(), description.trim());

            setTitle("");
            setDescription("");
            toast.success("Feedback o reporte enviado correctamente.");

        } catch (error) {
            toast.error("Hubo un error al enviar el feedback.");
        } finally {
            setIsSendingFeedback(false);
        }
    };


    return (
        <div className="flex justify-center">
            <Drawer >
                <DrawerTrigger
                    asChild
                    className="fixed bottom-30 right-4 rounded-full bg-blue-600 p-2 text-white shadow-lg hover:bg-blue-700 transition-colors dark:bg-yellow-500 dark:hover:bg-yellow-600"
                >
                    <button type="button" className="cursor-pointer">
                        <MessageSquareMore className="h-4 w-4" />
                    </button>
                </DrawerTrigger>


                <DrawerContent className="font-outfit">
                    <DrawerHeader>
                        <img src="/images/wist-dark.png" className="w-20 h-auto hidden dark:block" alt="" />
                        <img src="/images/wist-light.png" className="w-20 h-auto block dark:hidden" alt="" />
                        <DrawerTitle>Envía tu feedback o reporte</DrawerTitle>
                        <DrawerDescription>Tu opinión nos ayuda a mejorar.</DrawerDescription>
                    </DrawerHeader>

                    <form className="p-4 grid gap-4" onSubmit={(event) => { event.preventDefault(); handleSendFeedback(); }}>
                        <div className="grid gap-2">
                            <Label htmlFor="title">Título</Label>
                            <Input id="title" name="title" placeholder="Ingresa el título del reporte o feedback..." value={title} onChange={(event) => setTitle(event.target.value)} />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="feedback">Descripción</Label>
                            <Textarea id="description" placeholder="ingresa la descripción.." name="description" autoFocus value={description} onChange={(event) => setDescription(event.target.value)} />
                        </div>
                        <div className="flex flex-col gap-4 mt-4 sm:flex-row sm:justify-end">
                            <Button
                                type="submit"
                                className="cursor-pointer w-full sm:w-auto"
                                disabled={isSendingFeedback}
                            >
                                {isSendingFeedback ? (
                                    <>
                                        <Loader className="mr-2 h-4 w-4 animate-spin" />
                                        Enviando...
                                    </>
                                ) : (
                                    <>
                                        <Send className="mr-2 h-4 w-4" />
                                        Enviar
                                    </>
                                )}
                            </Button>

                            <DrawerClose asChild>
                                <Button variant="outline" className="cursor-pointer w-full sm:w-auto">
                                    Cancelar
                                </Button>
                            </DrawerClose>
                        </div>


                    </form>
                    <DrawerFooter />
                </DrawerContent>
            </Drawer>


        </div>
    )
}

export default Feedback;